module.exports = __webpack_public_path__ + "img/footer_back.8a0e8c54.png";